const PAGE_WRAPPER_SELECTOR = '.page-wrapper';

export const getScrollContainer = (): HTMLElement | Window => {
  const pageWrapper = document.querySelector<HTMLElement>(PAGE_WRAPPER_SELECTOR);
  
  if (pageWrapper) {
    const hasScrollableContent = 
      pageWrapper.querySelector('.rgs-collections') ||
      pageWrapper.querySelector('.account__nav') ||
      pageWrapper.querySelector('.price-breakdown-side');
    
    if (hasScrollableContent) {
      return pageWrapper;
    }
  }
  
  return window;
};

export const getScrollY = (container: HTMLElement | Window): number => {
  if (container instanceof HTMLElement) {
    return container.scrollTop;
  }
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
};
